import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalConfig';
import { ThemeProvider } from './contexts/ThemeContext';
import { EnvProvider } from './contexts/EnvContext';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000,
    },
  },
});

async function initializeApp() {
  await msalInstance.initialize();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <EnvProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </EnvProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}

initializeApp();
